import { render, staticRenderFns } from "./ChallengeChildApprove.vue?vue&type=template&id=3968ff1f&scoped=true&"
import script from "./ChallengeChildApprove.vue?vue&type=script&lang=js&"
export * from "./ChallengeChildApprove.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeChildApprove.vue?vue&type=style&index=0&id=3968ff1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3968ff1f",
  null
  
)

export default component.exports